import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const toastedApi = dmApi.injectEndpoints({
    endpoints: (build) => ({

        getToastedSortingRecord: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/toasted/sorting-record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['toastedSorting'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createToastedSortingData: build.mutation({
            query: (requestBody) => ({
                url: `/rework/toasted/sorting-create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['toastedSorting','toasted'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data");
            },
        }),

        updateToastedSortingData: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/rework/toasted/sorting-update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['toastedSorting'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data");
            },
        }),

    }),
});

export const {
    useGetToastedSortingRecordQuery,
    useCreateToastedSortingDataMutation,
    useUpdateToastedSortingDataMutation,
} = toastedApi;
